export default "__VITE_ASSET__BM80FfTa__"